// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__qEP3_","interactive":"Card_interactive__f7luR","outlined":"Card_outlined__uy0qq"};